
<mat-form-field appearance="fill">
  <mat-label>Type</mat-label>
  <mat-select (selectionChange)="changeType($event)" [(value)]="selected._id">
    <mat-option *ngFor="let type of types" [value]="type._id">
      {{type.name}}
    </mat-option>
  </mat-select>
</mat-form-field>
